import React, { useEffect } from "react";
import FeatherIcon from "feather-icons-react";
import { AgendaByRut } from "src/graphql/agenda";
import CobranzaGestionHistoryList from "./CobranzaGestionHistoryList";
import "./cobranzaGestionHistory.scss";

export default function CobranzaGestionHistorySidebar({
  openSidebar,
  closeMenu,
  closeMenuFunctions,
  dispatch,
  importOpenSidebar,
  companyId,
}) {
  const row = openSidebar?.editData?.row;
  const clientDocs = openSidebar?.editData?.clientDocs || [];
  const rut = row?.issuerRut || "";
  const { data, fetching, reexecuteQuery: reexecuteAgendaQuery } = AgendaByRut(rut, companyId, "cl");

  useEffect(() => {
    if (!rut || !companyId) return;
    reexecuteAgendaQuery?.({ requestPolicy: "network-only" });
  }, [rut, companyId, reexecuteAgendaQuery]);

  const handleBack = () => {
    if (typeof closeMenuFunctions?.cobranzaGestionHistoryView === "function") {
      closeMenuFunctions.cobranzaGestionHistoryView();
      return;
    }
    dispatch(
      importOpenSidebar({
        ...openSidebar,
        show: true,
        cobranzaGestion: true,
        cobranzaGestionHistoryView: false,
      })
    );
  };

  return (
    <div
      className="rightsidebar-content-panel cf-cobranza-history-panel"
      style={{ height: "100%" }}
    >
      <div className="rightsidebar-content-header">
        <div className="d-flex align-items-center" style={{ gap: "8px" }}>
          <button
            type="button"
            onClick={handleBack}
            className="rightsidebar-header-icon-btn"
            title="Volver a gestión"
          >
            <FeatherIcon icon="arrow-left" size={20} strokeWidth={2} />
          </button>
          <h3 className="rightsidebar-content-header-title" style={{ margin: 0 }}>
            Historial
          </h3>
        </div>
        <div className="d-flex align-items-center" style={{ gap: "8px" }}>
          <button
            type="button"
            onClick={() =>
              dispatch(
                importOpenSidebar({
                  ...openSidebar,
                  sidebarExpanded: !openSidebar?.sidebarExpanded,
                })
              )
            }
            className="rightsidebar-header-icon-btn"
            title={openSidebar?.sidebarExpanded ? "Contraer" : "Expandir"}
          >
            <FeatherIcon
              icon={openSidebar?.sidebarExpanded ? "minimize-2" : "maximize-2"}
              size={20}
              strokeWidth={2}
            />
          </button>
          <button
            type="button"
            onClick={closeMenu}
            className="rightsidebar-header-icon-btn cursor-pointer"
            title="Cerrar barra"
          >
            <FeatherIcon icon="x" size={20} strokeWidth={2} />
          </button>
        </div>
      </div>
      <div className="rightsidebar-content-body">
        {fetching && !data?.AgendaByRut ? (
          <p className="cf-gestion-detail-panel__loading">Cargando historial…</p>
        ) : (
          <CobranzaGestionHistoryList
            row={row}
            agenda={data?.AgendaByRut}
            clientDocs={clientDocs}
          />
        )}
      </div>
    </div>
  );
}
